import { useEffect, useMemo, useState } from 'react';

import FavoriteIcon from '@mui/icons-material/Favorite';
import { Skeleton, useTheme } from '@mui/material';
import userAPI, { USER_END_POINT } from 'src/api/user';
import { useSWRConfig } from 'swr';

import { IconButtonStyle } from '@components/share/custom/likeAndShareCourse/style';
import { useCourseWishlist } from '@hooks/useCourseWishlist';
import { useProfile } from '@hooks/useProfile';

type FavoriteCourseIconButtonProps = {
  courseId: number;
};

const FavoriteCourseIconButton = ({ courseId }: FavoriteCourseIconButtonProps) => {
  const [isClickedWishList, setIsClickedWishList] = useState<boolean>(false);
  const { mutate } = useSWRConfig();
  const { profile, isLoading } = useProfile();
  const theme = useTheme();

  const { wishlist, wishlistLoading, isValidating } = useCourseWishlist(courseId);

  const isInWishlist = useMemo(() => {
    return !!wishlist;
  }, [wishlist]);

  const updateWishlist = async () => {
    if (isClickedWishList) {
      setIsClickedWishList(false);
      mutate(USER_END_POINT.USER_ME_WISHLIST_COURSES, { data: null }, false);
      await userAPI.deleteUserWishlist(courseId);
    } else {
      setIsClickedWishList(true);
      mutate(USER_END_POINT.USER_ME_WISHLIST_COURSES, { data: { wishlist: { course_id: courseId } } }, false);
      await userAPI.createUserWishlist({ courseId });
    }
    mutate(USER_END_POINT.USER_ME_WISHLIST_COURSES);
  };

  useEffect(() => {
    setIsClickedWishList(isInWishlist);
  }, [isInWishlist]);

  if (isLoading || (wishlistLoading && isValidating)) {
    return (
      <IconButtonStyle>
        <Skeleton variant="circular" width={30} height={30} />
      </IconButtonStyle>
    );
  }
  if (!profile) {
    return null;
  }

  return (
    <IconButtonStyle onClick={updateWishlist}>
      <FavoriteIcon
        className="icon"
        sx={{ fill: isClickedWishList ? theme.palette.errorV2.main : 'transparent', fontSize: '24px' }}
      />
    </IconButtonStyle>
  );
};

export default FavoriteCourseIconButton;
